!(function (sb) {
	var me = (sb.DynamicIconShapeCache = {});
	var DynamicIconShapeCache = {};

	me.setDynamicIconShapeContentToCache = function (data, id) {
		DynamicIconShapeCache[id] = data;
	};
	me.getDynamicIconShapeContentFromCache = function (id) {
		return DynamicIconShapeCache[id];
	};
})(window.Storyboard = (window.Storyboard || {}));

window.DynamicIconShapeSetup = {
	isLoaded: false,
	templateId: null,
	setupEditPanel: function (elementItem) {
		DynamicIconShapeSetup.resetControls(elementItem);

		// make sure that filters are loaded first
		if (!DynamicIconShapeSetup.isLoaded) {
			Storyboard.Dependency.start('DYNAMICICONSHAPESETUP', 'filters');
			var loadingBar = Storyboard.LayoutControls.showLoadingBar('Loading filters');
			ChartSetupProxy.GetFilters(function(filters) {
				DynamicIconShapeSetup.bindFilters(filters);
				DynamicIconShapeSetup.loadDynamicIconShapeSettings(elementItem);
				DynamicIconShapeSetup.isLoaded = true;
				Storyboard.Dependency.complete('DYNAMICICONSHAPESETUP', 'filters');
				Storyboard.LayoutControls.hideLoadingBar(loadingBar);
			});
		} else {
			DynamicIconShapeSetup.loadDynamicIconShapeSettings(elementItem);
		}
	},

	loadDynamicIconShapeSettings: function(elementItem) {
		Storyboard.Dependency.start('DYNAMICICONSHAPESETUP', 'settings');
		Helpers.perfJSonCall({
			method: "GetDynamicIconShapeSettings",
			message: "Loading settings",
			data: {
				guid: elementItem.guid, elementItemId: elementItem.elementItemId || 0
			},
			successCallback: function (settings) {
				if (settings)
					DynamicIconShapeSetup.getTemplateData(DynamicIconShapeSetup.templateId, settings.templateElementItemId);
				DynamicIconShapeSetup.bindDynIconShapeSettings(settings);
				Storyboard.Dependency.complete('DYNAMICICONSHAPESETUP', 'settings');
			},
			failCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to load dynamic icon/shape settings."));
			},
			fixCasing: true
		});
	},

	updatePreview: function () {
		$("#divDynamicIconPreview, #divDynamicIconValueTable").empty();

		var dynIconShapeSettings = DynamicIconShapeSetup.getDynIconShapeSettings();
		if (!DynamicIconShapeSetup.validateSettings(dynIconShapeSettings))
			return false;

		Helpers.perfJSonCall({
			method: "GetDynamicIconShapePreview",
			message: "Rendering preview",
			data: {
				dynamicIconShape: dynIconShapeSettings,
				generalSettings: GeneralSettings.getSelectedSettings()
			},
			successCallback: function (contentData) {
				if (contentData) {
					$("#divDynamicIconPreview").empty();
					$("#divDynamicIconPreview")[0].innerHTML = IconShapeUI.fixGUIDs(contentData.Content);
					IconShapeUI.updateIconShapeElementSize(null, $("#divDynamicIconPreview"));
					$("#divDynamicIconValueTable").html(contentData.TableHtml);

					$("#divDynamicIconPreview, .showValueTable, .showChangeOrder, .invertBackground", "#dynamicIconPreview").show();
					$("#divDynamicIconValueTable").toggle($("#chbShowIconValueTable").is(":checked"));
				}
			},
			failedCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to generate preview."));
			}
		});
	},

	resetControls: function (elementItem) {
		$("#hidDynamicIconShapeId").val("");
		$("#hidCompareItemsOrder").val(0);
		$("#txtDISQuestion").val("");
		$("#txtDISAnswer").val("");
		$("#chbPartlyFill").removeAttr("checked");
		$("#chkUseWeightDin").attr("checked", true);
		$("#ddlWeights").val(1);

		$(".disCompareFilterChk").removeAttr("checked");
		$("#tblColorZones > tbody > .iconZoneRow:not('.iconZoneTemplate')").remove();
		HTMLHelpers.setSelectedValues("#disQuestionBox", 0);
		HTMLHelpers.setSelectedValues("#disAnswerBox", 0);
		HTMLHelpers.setSelectedValues("#ddlDISComparisonType", 1);
		HTMLHelpers.setSelectedValues("#ddlDISInterval", 27);

		DynamicIconShapeSetup.clearFilterSelections();
		DynamicIconShapeSetup.resetOptionalSettings();
		DynamicIconShapeSetup.resetTimeSettings();

		$("#divDynamicIconPreview, #divDynamicIconValueTable").empty();
		$("#dynamicIconPreview > div").hide();
		$("#chbShowIconValueTable").attr("checked", true);
		$("#iconPreviewDiv, #divDynamicIconPreview").css({width: elementItem.width, height: elementItem.height });
		$("#chbInvertDynamicIconPreview").removeAttr("checked").trigger("change");
		$('#txtFillColor, #txtBgColor').DUIColorPicker({ layout: "template" });
		$("#chbDISAllowExcelExport").removeAttr("checked");
	},

	bindDynIconShapeSettings: function (settings) {
		if (settings) {
			$("#hidDynamicIconShapeId").val(settings.dynamicIconShapeId);
			$("#ddlDISCalculationType").val(settings.questionSelections.calculationType || 1);
			HTMLHelpers.setSelectedValues("#ddlDISComparisonType", settings.compareType || 1);
			HTMLHelpers.setSelectedValues("#DISnumericPercentileValue", settings.numericPercentileVal || 1);
			// case 35975:
			DynamicIconShapeSetup.compareTypeChanged();

			$("#ddlDISCorrelationOption").val(settings.correlationSettings.correlationOption || 1);

			$("#hidCompareItemsOrder").val(settings.compareOrder || 0);

			HTMLHelpers.setSelectedValues("#ddlDISTimePeriod", settings.timePeriod >= 0 ? settings.timePeriod : 20);
			$("#txtDISTimeSpanAmount").val(settings.timePeriodSpanAmount > 0 ? settings.timePeriodSpanAmount : "");
			HTMLHelpers.setSelectedValues("#ddlDISTimeSpan", settings.timePeriodSpan);
			HTMLHelpers.setSelectedValues("#ddlDISDateVar", settings.dateVariableId || 1);
			$("#txtDISStartDate").datepicker("setDate", Helpers.parseDate(settings.strStartDate));
			$("#txtDISStopDate").datepicker("setDate", Helpers.parseDate(settings.strStopDate));
			HTMLHelpers.setSelectedValues("#ddlDISInterval", settings.interval || 27);
			DynamicIconShapeSetup.showHideTimeSettings();

			$("#chbPartlyFill").attr("checked", settings.usePartialFill);

			$("#chkUseWeightDin").attr("checked", settings.useWeight);
			HTMLHelpers.setSelectedValues('#ddlWeights', settings.weightVariableId || 1);
			$('#ddlWeights').css("display", ($('#ddlWeights option').length == 1 ? "none" : ""));

			if (settings.gradient) {
				$("#ddlFillOrientation").val(settings.gradient.orientation);
				DynamicIconShapeSetup.setColorBoxValue($("#txtFillColor"), settings.gradient.fillColor, settings.gradient.fillColor_colorPlaceholderId);
				DynamicIconShapeSetup.setColorBoxValue($("#txtBgColor"), settings.gradient.backgroundColor, settings.gradient.backgroundColor_colorPlaceholderId);
			}

			$("#txtRangeMin").val(settings.expectedMin || 0);
			$("#txtRangeMax").val(settings.expectedMax || 0);

			$("#chbDISAllowExcelExport").attr("checked", settings.allowExcelExport);

			DynamicIconShapeSetup.filterQuestions(settings.questionSelections.questions, settings.questionSelections.answers);
			DynamicIconShapeSetup.filterCorrelationQuestions(settings.correlationSettings.questionId);
			DynamicIconShapeSetup.setSelectedFilters(settings.filters);
			DynamicIconShapeSetup.setOptionalFilterSettings(settings.optionalSettings);
			DynamicIconShapeSetup.setZones(settings.colorZones, settings.usePartialFill);
		} else {
			DynamicIconShapeSetup.filterQuestions();
			DynamicIconShapeSetup.filterCorrelationQuestions();
			DynamicIconShapeSetup.compareTypeChanged();
		}

		DynamicIconShapeSetup.showHideZonesTable();
		DynamicIconShapeSetup.showHideStyleSettings();
		DynamicIconShapeSetup.hideCorrelationSettings();
	},

	setSelectedFilters: function (filters) {
		DynamicIconShapeSetup.clearFilterSelections();

		if (filters) {
			filters.forEach(function(filter) {
				if (!filter.filterId) return;
				var filterbox = $("#disFilterBox div #hidFilterId[value='" + filter.filterId + "']").parent();

				if (filter.allAnswers)
					HTMLHelpers.setSelectedValues(filterbox.find('select'), "all");
				else {
					var answerIds = $.map(filter.answers, function (e) { return isNaN(e.answerId) ? e : e.answerId });
					HTMLHelpers.setSelectedValues(filterbox.find("select"), answerIds);
				}
				filterbox.find("#chkDISCompare").attr("checked", filter.compare);
				filterbox.find(".disFilterOptions").change();
			});
		}
	},

	setOptionalFilterSettings: function (optionalSettings) {
		if (optionalSettings) {
			optionalSettings.forEach(function(os) {
				switch(os.settingType) {
					case 1:
						$("#chkDISOptVariableSubset").attr("checked", os.apply);
						break;
					case 2:
						$("#chkDISOptHFilter").attr("checked", os.apply);
						break;
					case 3:
						DynamicIconShapeSetup.setOptionalFilterQuestions(os.questionId, os.apply);
						break;
					case 4:
						$("#chkDISOptTimePeriod").attr("checked", os.apply);
						break;
					case 6:
						$("#chkDISOptMovingAverage").attr("checked", os.apply);
						break;
				}
			});
		}

		var allChecked = $('#disOptionalFilterSettings input[type="checkbox"]')
			.filter(function() { return $(this).attr('id') !== 'chkOptFilter'; })
			.filter(function() { return !$(this).is(':checked'); })
			.length === 0;

		$('#disOptionalFilterSettings')
			.prev('.optionalFilterSettingsCheckAll').find('input[type="checkbox"]')
			.attr('checked', allChecked);
	},

	setOptionalFilterQuestions: function (questionId, apply) {
		$("#disOptionalFilterBox div").each(function () {
			if (questionId == $(this).find("#hidOptQuestionId").val())
				$(this).find(".chkOptFilter").attr("checked", apply);
		});
	},

	setZones: function (zones, usePartialFill) {
		var tableId = "tblColorZones", rowTemplateClass = "iconZoneTemplate";
		var template = $("." + rowTemplateClass);

		$(zones).each(function () {
			var newRow = template.clone();
			newRow.removeClass(rowTemplateClass).show();

			newRow.find("#txtStartValue").val(this.startValue);
			newRow.find("#txtStopValue").val(this.stopValue);
			newRow.find("#ddlStartCondition").val(this.startValueCondition);
			newRow.find("#ddlStopCondition").val(this.stopValueCondition);
			newRow.find("#hidZoneIconId").val(this.zoneIconShapeId);
			newRow.find("#zoneIconPreviewEl").html(IconShapeUI.fixGUIDs(this.content)).css('display', 'block');
			newRow.find(".editZoneIconSettings").css('display', 'none');
			$("#" + tableId + " > tbody:last").append(newRow);

			IconShapeUI.updateIconShapeElementSize(null, newRow.find("#zoneIconPreviewEl"));
			Storyboard.IconShapeCache.setIconShapeSettingsToCache({content: this.content}, "zoneIcon_" + this.zoneIconShapeId);
			if (usePartialFill) DynamicIconShapeSetup.setZoneGradient.call(newRow);
			DynamicIconShapeSetup.bindZoneRowEvents(newRow);
		});
	},

	setZoneGradient: function() {
		var gradientSettings = DynamicIconShapeSetup.getGradientSettings();
		var gradientObject = {
			orientation: gradientSettings.orientation,
			stops: [{"offset": "50%", "stop-color": gradientSettings.fillColor},
			{"offset": "50%", "stop-color": gradientSettings.backgroundColor}]
		};
		var svgElement = $(this).find('#zoneIconPreviewEl > svg').get(0);

		if (svgElement) {
			var stylesGroupEl = svgElement.querySelector("g.group-styles");
			var guid = Helpers.generateGuid();

			IconShapeUI.setGradient(gradientObject, stylesGroupEl, svgElement, guid);
		}
	},

	removeZoneGradient: function() {
		var zoneIconShapeId = $(this).find("#hidZoneIconId").val();
		var zoneIconPreviewEl = $(this).find("#zoneIconPreviewEl");
		var zoneSettings = Storyboard.IconShapeCache.getIconShapeSettingsFromCache("zoneIcon_" + zoneIconShapeId);
		if (zoneSettings && typeof zoneSettings.content === "string") {
			zoneIconPreviewEl[0].innerHTML = IconShapeUI.fixGUIDs(zoneSettings.content);
			IconShapeUI.updateIconShapeElementSize(null, zoneIconPreviewEl);
		}
	},

	bindZoneRowEvents: function(newRow) {
		newRow.find("#btnDeleteZone").bind("click", function () {
			if (!confirm("Are you sure you want to delete this zone?"))
				return;

			ChartSetupUI.removeRow(this, "iconZoneRow");
			DynamicIconShapeSetup.showHideZonesTable();
		});
		newRow.find(".editZoneIconSettings, #zoneIconPreviewEl").bind("click", function () {
			$(".zoneIconRowInEdit").removeClass("zoneIconRowInEdit");
			newRow.addClass("zoneIconRowInEdit");
			var zoneIconId = newRow.find("#hidZoneIconId").val() || 0;
			IconShapeSetup.setupLibraryEditPanel(zoneIconId, "#setupDynamicIconShapeTab");
		});
		newRow.find(".copyZoneButton").bind("click", function () {
			var rowCopy = newRow.clone();

			rowCopy.find("#ddlStartCondition").val(newRow.find("#ddlStartCondition").val());
			rowCopy.find("#ddlStopCondition").val(newRow.find("#ddlStopCondition").val());
			var iconId = newRow.find("#hidZoneIconId").val();
			if (iconId)
				IconShapeSetup.copyZoneIcon(iconId, rowCopy);

			DynamicIconShapeSetup.bindZoneRowEvents(rowCopy);
			$("#tblColorZones > tbody:last").append(rowCopy);
			DynamicIconShapeSetup.showHideZonesTable();
		});
	},

	getDynIconShapeSettings: function () {
		return {
			dynamicIconShapeId: $("#hidDynamicIconShapeId").val() || 0,

			timePeriod: $("#ddlDISTimePeriod").val() || 20,
			dateVariableId: $("#ddlDISDateVar").val() || 1,
			startDate: Helpers.formatDate($("#txtDISStartDate").datepicker("getDate")),
			stopDate: Helpers.formatDate($("#txtDISStopDate").datepicker("getDate")),
			timePeriodSpan: $("#ddlDISTimeSpan").val(),
			timePeriodSpanAmount: $("#txtDISTimeSpanAmount").val() || 0,
			interval: $("#ddlDISInterval").val() || 27,
			usePartialFill: $("#chbPartlyFill").is(":checked"),
			expectedMin: $("#txtRangeMin").val() || 0,
			expectedMax: $("#txtRangeMax").val() || 100,
			numericPercentileVal: $("#DISnumericPercentileValue").val() || 1,
			useWeight: $("#chkUseWeightDin").is(":checked"),
			weightVariableId: $("#ddlWeights").val(),
			gradient: DynamicIconShapeSetup.getGradientSettings(),
			compareType: $("#ddlDISComparisonType").val() || 1,
			compareOrder: $("#hidCompareItemsOrder").val() || 0,
			questionSelections: DynamicIconShapeSetup.getQuestionSelections(),
			filters: DynamicIconShapeSetup.getFilterSelections(),
			optionalSettings: DynamicIconShapeSetup.getOptionalSettings(),
			colorZones: DynamicIconShapeSetup.getZones(),
			correlationSettings: {
				questionId: $("#disCorrelationQuestionBox").val() || 0,
				correlationOption: $("#ddlDISCorrelationOption").val() || 1
			},
			allowExcelExport: $("#chbDISAllowExcelExport").is(":checked")
		};
	},

	getGradientSettings: function () {
		var gradient = {};
		var fillColor_colorPlaceholderId = $("#txtFillColor").DUIColorPicker("get.selectedColorId");
		var backgroundColor_colorPlaceholderId = $("#txtBgColor").DUIColorPicker("get.selectedColorId");

		gradient.orientation = $("#ddlFillOrientation").val() || "horizontal";
		gradient.fillColor = DynamicIconShapeSetup.getColorBoxValue($("#txtFillColor")[0]);
		gradient.backgroundColor = DynamicIconShapeSetup.getColorBoxValue($("#txtBgColor")[0]);

		if (fillColor_colorPlaceholderId)
			gradient.fillColor_colorPlaceholderId = fillColor_colorPlaceholderId;
		if (backgroundColor_colorPlaceholderId)
			gradient.backgroundColor_colorPlaceholderId = backgroundColor_colorPlaceholderId;

		return gradient;
	},

	// TODO: move to helpers?
	getColorBoxValue: function (box) {
		return (typeof box.style.backgroundColor == "undefined" ||
			box.style.backgroundColor.replace(/ /g, "").indexOf("(255,255,255,0") > -1 ||
			box.style.backgroundColor.toLowerCase() === "transparent")
			? "rgba(255, 255, 255, 0.001)"
			: box.style.backgroundColor;
	},

	// TODO: move to helpers?
	setColorBoxValue: function (box, color, colorId) {
		color = (color.toLowerCase().replace(/ /g, "").indexOf("(255,255,255,0") > -1) ? "transparent" : color;
		box.DUIColorPicker({
			layout: "template",
			selected: {
				colorString: color,
				templateColorId: colorId
			}
		});
		box.change();
	},

	getQuestionSelections: function () {
		var questionSelections = {
			questions: [],
			answers: [],
			questionBlocks: [],
			variableSubsets: [],
			gridQuestions: [],
			calculationType: $("#ddlDISCalculationType").val()
		};

		$("#disQuestionBox option:selected").each(function () { questionSelections.questions.push($(this).val()); });

		if (questionSelections.calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT ||
			questionSelections.calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_COUNT) {
			$("#disAnswerBox option:selected").each(function () { questionSelections.answers.push($(this).val()); });

			if (questionSelections.calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT) {
				questionSelections.answersExcludedFromPercentage = [];
				if (questionSelections.answers.length)
					$('#disAnswerBox option[excludeFromPercentage="true"]').each(function () { questionSelections.answersExcludedFromPercentage.push($(this).val()); });
			}
		}

		else
			$("#disAnswerBox option").each(function () { questionSelections.answers.push($(this).val()); });

		return questionSelections;
	},

	getFilterSelections: function () {
		var filters = [];

		$("#disFilterBox > div:not('.disFilterboxTemplate')").each(function () {
			var filterId = $(this).find("#hidFilterId").val();
			var questionId = $(this).find("#hidQuestionId").val();
			var compare = $(this).find("#chkDISCompare").is(":checked");
			var allAnswers = $(this).find("select option[value='all']:selected").length > 0;

			var selectedAnswers = $(this).find(allAnswers ? "select option" : "select option:selected").
				filter(function () { return $(this).val() != "0" && $(this).val() != "all"; }).
				map(function () {
					return { answerId: $(this).val(), answerText: $(this).text() };
				}).toArray();

			var filterText = $(this).find("h3").text();

			if ($(selectedAnswers).length > 0 && filterId > 0) {
				var filter = {
					filterId: filterId,
					answers: selectedAnswers,
					questionId: questionId,
					filterText: filterText,
					compare: compare,
					allAnswers: allAnswers
				};

				filters.push(filter);
			}
		});

		return filters;
	},

	getOptionalSettings: function () {
		var optFilterSettings = [];

		// variable subset
		optFilterSettings.push({
			dynamicIconShapeId: $("#hidDynamicIconShapeId").val() || 0,
			settingType: 1,
			apply: $("#chkDISOptVariableSubset").is(":checked")
		});

		// hfilter
		optFilterSettings.push({
			dynamicIconShapeId: $("#hidDynamicIconShapeId").val() || 0,
			settingType: 2,
			apply: $("#chkDISOptHFilter").is(":checked")
		});

		$("#disOptionalFilterBox div").each(function () {
			if ($(this).find("#hidOptFilterId").val() > 0)
				optFilterSettings.push({
					dynamicIconShapeId: $("#hidDynamicIconShapeId").val() || 0,
					settingType: 3,
					filterId: $(this).find("#hidOptFilterId").val(),
					questionId: $(this).find("#hidOptQuestionId").val() || 0,
					apply: $(this).find(".chkOptFilter").is(":checked")
				});
		});

		// time period
		optFilterSettings.push({
			dynamicIconShapeId: $("#hidDynamicIconShapeId").val() || 0,
			settingType: 4,
			apply: $("#chkDISOptTimePeriod").is(":checked")
		});

		// interval - disabled for now
		optFilterSettings.push({
			dynamicIconShapeId: $("#hidDynamicIconShapeId").val() || 0,
			settingType: 5,
			apply: false
		});

		// moving average
		optFilterSettings.push({
			dynamicIconShapeId: $("#hidDynamicIconShapeId").val() || 0,
			settingType: 6,
			apply: $("#chkDISOptMovingAverage").is(":checked")
		});

		return optFilterSettings;
	},

	getZones: function() {
		var tableId = "tblColorZones", rowTemplateClass = "iconZoneTemplate";
		var zones = [];
		$("#" + tableId + " > tbody > .iconZoneRow:not('." + rowTemplateClass + "')").each(function () {
			if ($(this).css("display") == "none")
				return;

			zones.push({
				dynamicIconShapeId: $("#hidDynamicIconShapeId").val() || 0,
				startValue: $(this).find("#txtStartValue").val(),
				startValueCondition: $(this).find("#ddlStartCondition").val(),
				stopValue: $(this).find("#txtStopValue").val(),
				stopValueCondition: $(this).find("#ddlStopCondition").val(),
				zoneIconShapeId: $(this).find("#hidZoneIconId").val(),
				content: $(this).find("#zoneIconPreviewEl")[0].innerHTML
			});
		});

		return zones;
	},

	saveSetup: function (dynIconShapeElementItem) {
		var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(dynIconShapeElementItem);

		var data = {
			elementItem: dynIconShapeElementItem,
			dynamicIconShape: DynamicIconShapeSetup.getDynIconShapeSettings()
		};

		if (!DynamicIconShapeSetup.validateSettings(data.dynamicIconShape))
			return false;

		Helpers.perfJSonCall({
			method: "SaveDynamicIconShapeSettings",
			message: "Saving dynamic icon/shape settings",
			data: data,
			successCallback: function () {
				$('#' + layoutElement.guid).removeClass('ui-invalid');
				Storyboard.LayoutControls.showMessage(locale.get("Icon/shape settings have been saved."));
				Storyboard.LayoutDesigner.loadStorytellerContentForElements([layoutElement], true, false, 0, 0);
			},
			failedCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get("Unable to save icon/shape settings."));
			}
		});

		return true;
	},

	validateSettings: function (settings) {
		var types = Storyboard.Constants.DynamicIconShapeCompareTypes;

		if (settings.compareType == types.Questions) {
			if (settings.questionSelections.questions.length != 2) {
				Storyboard.LayoutControls.showMessage(locale.get("Please select 2 variables."));
				return false;
			}
		} else if (settings.questionSelections.questions.length < 1) {
			Storyboard.LayoutControls.showMessage(locale.get("Please select variable."));
			return false;
		}

		// don't check answers for mean and numeric questions
		if (settings.questionSelections.calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT ||
			settings.questionSelections.calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_COUNT) {
			if (settings.compareType == types.Answers) {
				if (settings.questionSelections.answers.length != 2) {
					Storyboard.LayoutControls.showMessage(locale.get("Please select 2 answers."));
					return false;
				}
			} else if (settings.questionSelections.answers.length < 1) {
				Storyboard.LayoutControls.showMessage(locale.get("Please select answer."));
				return false;
			}
		}

		if (settings.questionSelections.calculationType == Storyboard.Constants.CalculationTypes.CORRELATION_ANALYSIS &&
			!settings.correlationSettings.questionId) {
			Storyboard.LayoutControls.showMessage(locale.get("Please set question to test against."));
			return false;
		}

		if (settings.compareType == types.CompareFilter) {
			if (settings.filters.length < 1 || $(settings.filters).filter(function () { return this.compare; }).length != 1) {
				Storyboard.LayoutControls.showMessage(locale.get("Please set 1 compare filter."));
				return false;
			}

			var compareFilter = $(settings.filters).filter(function () { return this.compare; })[0];
			if (compareFilter.answers.length != 2) {
				Storyboard.LayoutControls.showMessage(locale.get("Please select 2 answers for compare filter."));
				return false;
			}
		}

		if ($(settings.colorZones).filter(function () { return !this.zoneIconShapeId; }).length > 0) {
			Storyboard.LayoutControls.showMessage(locale.get("Please set icon / shape for all zones."));
			return false;
		}

		return true;
	},

	redrawDynamicIconShape: function (dynIconShapeElem, contentData) {
		var element = $("#" + dynIconShapeElem.guid);
		contentData = contentData ? contentData : Storyboard.DynamicIconShapeCache.getDynamicIconShapeContentFromCache(dynIconShapeElem.guid);
		var content = contentData ? contentData.Content : "";
		var svg;

		element.empty();
		Storyboard.DynamicIconShapeCache.setDynamicIconShapeContentToCache(contentData, dynIconShapeElem.guid);

		try {
			if (content) {
				if (content === "No Data") {
					if (Storyboard.LayoutDesigner.useNewNoDataLayout) {
						element.removeClass("layoutElementDynamicIconShape").addClass("layoutElementNoDataText")
							.html($('<span/>', { 'class': 'noData', html: locale.get('no data') }))
							.css({ 'background-image': '' });
					} else {
						element.removeClass("layoutElementDynamicIconShape").addClass("layoutElementNoData")
							.css({ 'background-image': '' });
					}
				} else {
					element.html(IconShapeUI.fixGUIDs(content, dynIconShapeElem.guid));
					svg = $(element).find('svg');
					svg.find("title").remove();
					IconShapeUI.EventsManager.addEventsToSvgElement(svg.get(0));

					element
						.removeClass("layoutElementNoData layoutElementNoDataText")
						.addClass("layoutElementDynamicIconShape");

					if (!Helpers.isPreview())
						element.css({ 'background-image': "none" });

					IconShapeUI.updateIconShapeElementSize(dynIconShapeElem);

					if (contentData.AllowExcelExport) {
						var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(dynIconShapeElem);
						Storyboard.GuiEvents.renderExcelExportOption(layoutElement, element, { allowExcelExport: true });
					}
				}
			}
		}
		catch (e) {
			Helpers.logErr(e);
		}
	},

	loadTabs: function () {
		$("#dynIconShapeSettingsTabHolder").tabs("destroy");
		$("#dynIconShapeSettingsTabHolder").removeClass("ui-widget");
		$("#dynIconShapeSettingsTabHolder").tabs({
			show: function (evt, ui) {
				$("#dynIconShapeSettingsTabHolder #panels").css("width", (ui.index === 3 ? "500px" : ""));
			}
		});
	},

	filterCorrelationQuestions: function (selectedId) {
		selectedId = selectedId || $("#disCorrelationQuestionBox").val();
		var filter = $("#txtDISCorrelationQuestion").val();

		ChartSetupProxy.GetFilterQuestions(filter, Storyboard.Constants.CalculationTypes.CORRELATION_ANALYSIS, "", "", "", false, "", 0, false, function (questionsArray) {
			HTMLHelpers.bindSelect($("#disCorrelationQuestionBox"), questionsArray, "questionId", "questionText");
			HTMLHelpers.setSelectedValues($("#disCorrelationQuestionBox"), selectedId);
		});
	},

	filterQuestions: function (selectedQuestions, selectedAnswers) {
		selectedQuestions = selectedQuestions || $("#disQuestionBox").val();

		var filter = $("#txtDISQuestion").val();
		var calculationType = $("#ddlDISCalculationType").val() || 1;

		if (calculationType == '11') {
			$('#DISnumericPercentileValue').show();
			$('#DISsbTextNumericPercentile').show();
		}
		else {
			$('#DISnumericPercentileValue').hide();
			$('#DISsbTextNumericPercentile').hide();
		}

		if ((calculationType == '8') || (calculationType == '9') || (calculationType == '10') || (calculationType == '11'))
			$('#DISsbTextNumericNote').show();
		else
			$('#DISsbTextNumericNote').hide();

		$(".disAnswerWrapper").toggle(calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT ||
			calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_COUNT);
		DynamicIconShapeSetup.hideCorrelationSettings();

		Storyboard.LayoutControls.showLoadingBar("Loading variables");
		ChartSetupProxy.GetFilterQuestions(filter, calculationType, "", "", "", $("#chbDISShowQuestionCode").attr("checked"), "", 0, false, function (questionsArray) {
			for (var i in questionsArray) {
				questionsArray[i].title = questionsArray[i].questionText;
				questionsArray[i].aiIcon = questionsArray[i].isAicompute ? Storyboard.Constants.aiIconEntity : '';
			}
			HTMLHelpers.bindSelect(
				$("#disQuestionBox"),
				questionsArray,
				"questionId", "questionText",
				false, false, false, false,
				["aiIcon", "title", "code", "questionText", "loopImportId", "isLoopIterator", "isHiddenLoopIterator"],
				false,
				useNewLoopVisualization ? { id: "loopImportId", text: "loopName" } : null
			);
			if (useNewLoopVisualization)
				$('option[isHiddenLoopIterator="true"]', $('#disQuestionBox')).addClass('hidden');
			if ($("#chbDISShowQuestionCode").is(":checked"))
				HTMLHelpers.resetOptionsTexts($("#disQuestionBox"), ["code", "questionText"], " - ");
			HTMLHelpers.setSelectedValues($("#disQuestionBox"), selectedQuestions);
			DynamicIconShapeSetup.filterAnswers(selectedAnswers);
			Storyboard.LayoutControls.hideLoadingBar();
		});
	},

	filterAnswers: function (selectedAnswers) {
		DynamicIconShapeSetup.disableEnableQuestionOptions();
		selectedAnswers = selectedAnswers || $("#disAnswerBox").val();

		var selections = {
			selectedQuestions: $("#disQuestionBox").val(),
			filter: $("#txtDISAnswer").val(),
			variableSubsets: "",
			calculationType: $("#ddlDISCalculationType").val() || "",
			filterByRowNo: $("#chbDISShowAnswerId").attr("checked")
		};
		ChartSetupProxy.GetAnswers(selections, function (answers) {
			var answersArray = answers.filter(item => item.rowNo !== 999);
			var $answerBox = $("#disAnswerBox");

			var extraAttributes = ["answerText", "rowNo"];
			var isCategoricalPercent = $("#ddlDISCalculationType").val() == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT;
			if (isCategoricalPercent)
				extraAttributes.push('excludeFromPercentage');

			HTMLHelpers.bindSelect($answerBox, answersArray, "answerId", "answerText", false, false, false, false, extraAttributes);
			if ($("#chbDISShowAnswerId").is(":checked"))
				HTMLHelpers.resetOptionsTexts($answerBox, ["rowNo", "answerText"], " - ");
			HTMLHelpers.setSelectedValues($answerBox, selectedAnswers);
			DynamicIconShapeSetup.disableEnableOptions($answerBox);

			if (isCategoricalPercent)
				$answerBox.find('option[excludeFromPercentage="true"]').css({ 'font-style': 'italic', 'color': 'darkgray' });

			$("#disAnswerBoxInfo_cc").toggle(isCategoricalPercent && answersArray.some(a => a.excludeFromPercentage));
		});
	},

	bindFilters: function (filterArray) {
		Storyboard.GuiEvents.bindFilters(filterArray, "disFilterBox", "disFilterboxTemplate", true);
		Storyboard.GuiEvents.bindOptionalFilters(filterArray, "disOptionalFilterBox", "disOptionFilterTemplate", "disOptionalFilterSettings");
		Storyboard.GuiEvents.bindOptionalFiltersCheckAll("disOptionalFilterBox");
		$(".disCompareFilterChk").change(function () {
			var selectBox = $(this).closest("div").find(".disFilterOptions");

			if ($(this).is(":checked")) {
				$(".disCompareFilterChk").removeAttr("checked");
				$(this).attr("checked", "checked");

				var selectedValues = selectBox.val();
				if (selectedValues && selectedValues.length > 2)
					HTMLHelpers.setSelectedValues(selectBox, [selectedValues[0], selectedValues[1]]);

				DynamicIconShapeSetup.disableEnableOptions(selectBox);
			} else
				$(selectBox).find("option").removeAttr("disabled");
		});
		$("#disFilterBox .disFilterOptions").bind("change, mousemove", function () {
			if ($(this).closest("div").find(".disCompareFilterChk").is(":checked"))
				DynamicIconShapeSetup.disableEnableOptions($(this));
			else
				$(this).find("option").removeAttr("disabled");
		});
	},

	// UI thingies

	addNewColorZone: function () {
		var tableId = "tblColorZones", rowTemplateClass = "iconZoneTemplate";
		var newRow = ChartSetupUI.addRowFromTemplate(tableId, rowTemplateClass);
		DynamicIconShapeSetup.bindZoneRowEvents(newRow);
		DynamicIconShapeSetup.showHideZonesTable();
	},

	updateThumbnail: function (iconShape) {
		$(".zoneIconRowInEdit").find("#hidZoneIconId").val(iconShape.iconShapeId);
		$(".zoneIconRowInEdit").find("#zoneIconPreviewEl").html(IconShapeUI.fixGUIDs(iconShape.content)).css('display', 'block');
		IconShapeUI.updateIconShapeElementSize(null, $(".zoneIconRowInEdit").find("#zoneIconPreviewEl"));
		if ($("#chbPartlyFill").is(":checked"))
			DynamicIconShapeSetup.setZoneGradient.call($(".zoneIconRowInEdit"));
	},

	updateZonesStyles: function() {
		if ($("#chbPartlyFill").is(":checked"))
			$("#tblColorZones .iconZoneRow:not(.iconZoneTemplate)").each(DynamicIconShapeSetup.setZoneGradient);
		else
			$("#tblColorZones .iconZoneRow:not(.iconZoneTemplate)").each(DynamicIconShapeSetup.removeZoneGradient);
	},

	compareTypeChanged: function () {
		var types = Storyboard.Constants.DynamicIconShapeCompareTypes;
		var compareType = parseInt($("#ddlDISComparisonType").val(), 10);

		$("#btnChangeItemsOrder").toggle(compareType != types.SingleResult);

		if (compareType == types.Questions) {
			$("#disQuestionBox").attr("multiple", "multiple");
			DynamicIconShapeSetup.disableEnableQuestionOptions();
		} else {
			// TODO: deselect all but one
			$("#disQuestionBox").removeAttr("multiple");
			DynamicIconShapeSetup.disableEnableQuestionOptions();
		}

		if (compareType == types.Answers)
			$("#disAnswerBox").attr("multiple", "multiple");
		else {
			// TODO: deselect all but one
			$("#disAnswerBox").removeAttr("multiple");
		}

		if (compareType == types.CompareFilter) {
			$(".disCompareFilter").show();
		} else {
			$(".disCompareFilter").removeAttr("checked");
			$(".disCompareFilter").hide();
		}

		if (compareType == types.Intervals) {
			// show interval dropdown, disable full period, set Weeks as default
			$(".hdDISIntervals").show();
			$("#ddlDISInterval option[value='7']").attr("disabled", "disabled");
			$("#ddlDISInterval").val(2);
		} else {
			$(".hdDISIntervals").hide();
			$("#ddlDISInterval option[value='7']").removeAttr("disabled");
			$("#ddlDISInterval").val(27);
		}
		DynamicIconShapeSetup.showHideTimeSettings();
	},

	showHideZonesTable: function () {
		// have at least one row at all times
		if ($("#tblColorZones > tbody > .iconZoneRow:not('.iconZoneTemplate')").length < 1)
			DynamicIconShapeSetup.addNewColorZone();

		var zoneRows = $("#tblColorZones > tbody > .iconZoneRow:not('.iconZoneTemplate')");
		zoneRows.find(".deleteZoneButton").toggle(zoneRows.length > 1);
	},

	showHideTimeSettings: function () {
		var types = Storyboard.Constants.DynamicIconShapeCompareTypes;
		var compareType = parseInt($("#ddlDISComparisonType").val(), 10);

		if (compareType == types.Intervals) {
			$("#ddlDISTimePeriod").val(27);
			var interval = $("#ddlDISInterval").val();
			$("#ddlDISTimeSpan").val(interval);
			$("#txtDISTimeSpanAmount").val(2);
			$("#ddlDISTimePeriod, #ddlDISTimeSpan, #txtDISTimeSpanAmount").attr("disabled", "disabled");
		} else
			$("#ddlDISTimePeriod, #ddlDISTimeSpan, #txtDISTimeSpanAmount").removeAttr("disabled");

		$(".disTimePeriodSelections").toggle($("#ddlDISTimePeriod").val() == 0); // select start and stop date
		$(".disTimeSpanSelections").toggle($("#ddlDISTimePeriod").val() == 27); // select last
	},

	showHideStyleSettings: function(evt) {
		var usePartialFill = $("#chbPartlyFill").is(":checked");
		$(".iconPartialFillSettings, .valueRangeSettings").toggle(usePartialFill);
		if (evt instanceof $.Event) DynamicIconShapeSetup.updateZonesStyles();
	},

	toggleWeight: function(evt){
		var useWeight = $("#chkUseWeightDin").is(":checked");
		$("#ddlWeights").attr("disabled", !useWeight);
	},

	hideCorrelationSettings: function () {
		var show = $("#ddlDISCalculationType").val() == Storyboard.Constants.CalculationTypes.CORRELATION_ANALYSIS;
		$(".hdDISCorrelationOption").toggle(show);
		if (!show) {
			$("#disCorrelationQuestionBox").parent().css("display", "none");
			$("#disCorrelationQuestionBox option").attr("selected", false);
		}
		else
			$("#disCorrelationQuestionBox").parent().css("display", "");
	},

	disableEnableOptions: function(selectBox) {
		var last = $(selectBox).data('last');
		var $sel = $(selectBox).find(':selected');
		if ($sel.length < 2) {
			$(selectBox).find(':disabled').attr('disabled', false);
			$(selectBox).data('last', $(selectBox).val());
		} else if ($sel.length === 2) {
			$(selectBox).find(':not(:selected)').attr('disabled', true);
			$(selectBox).data('last', $(selectBox).val());
		} else {
			$(selectBox).find(':disabled').attr('disabled', false);
			$(selectBox).val(last);
		}
	},

	disableEnableQuestionOptions: function () {
		var qnBox = $('#disQuestionBox');
		if (qnBox.attr('multiple')) {
			var $sel = qnBox.find(':selected');
			if ($sel.length > 0) {
				$('option', qnBox).removeAttr('disabled');

				if (useNewLoopVisualization) {
					var selectedLoopId = $('option:selected', qnBox).first().attr('loopImportId');
					// disable qns from other loops
					$('option[loopImportId!="' + selectedLoopId + '"]', qnBox).removeAttr('selected');
					$('option[loopImportId!="' + selectedLoopId + '"]', qnBox).attr('disabled', 'disabled');

					$sel = qnBox.find(':selected');
				}

				if ($sel.length == 2) {
					$('option:not(:selected)', qnBox).attr('disabled', 'disabled');
				}
			} else {
				$('option', qnBox).removeAttr('disabled');
			}
		} else {
			$('option', qnBox).removeAttr('disabled');
		}

		DynamicIconShapeSetup.moveLoopIteratorFilter();
	},

	moveLoopIteratorFilter: function () {
		if (!useNewLoopVisualization)
			return;

		var qnBox = $('#disQuestionBox');
		var selectedLoopId = qnBox.find(':selected').length > 0 ? $('option:selected', qnBox).first().attr('loopImportId') : 0;

		// remove filters that do not belong to selected loop
		$('#disLoopIteratorFilters .settingItemBlock').each(function () {
			var filterBox = $(this);
			var loopImportId = filterBox.attr('loopImportId');

			if (loopImportId != selectedLoopId) {
				var qnId = $(this).find('#hidQuestionId').val();
				var placeholder = $('#disFilterBox .disLoopIteratorFilterPlaceholder[value="' + qnId + '"]');
				placeholder.before($(this));
				placeholder.remove();

				// deselect options and uncheck Compare
				HTMLHelpers.setSelectedValues(filterBox.find('select'), '0');
				filterBox.find('#chkDISCompare').attr('checked', false).attr('disabled', 'disabled');
			}
		});

		// add filters that do
		if (selectedLoopId > 0) {
			$('#disFilterBox .settingItemBlock[isLoopIterator="true"][loopImportId="' + selectedLoopId + '"]').each(function () {
				var filterBox = $(this);
				var qnId = $('.hidQuestionId', filterBox).val();
				if ($('#disQuestionBox option:selected[value="' + qnId + '"]').length === 0) {
					filterBox.after('<input type="hidden" class="disLoopIteratorFilterPlaceholder" value="' + qnId + '" />');
					$('#disLoopIteratorFilters').append(filterBox);
				}
			});
		}

		$('#disLoopIteratorFilters').toggle($('#disLoopIteratorFilters .settingItemBlock').length > 0);
	},

	disableForSelectedQuestions: function () {
		$("#disCorrelationQuestionBox option").removeAttr("disabled");
		$("#disQuestionBox option:selected").each(function () {
			$("#disCorrelationQuestionBox option[value='" + $(this).val() + "']").attr("disabled", "disabled");
			if ($("#disCorrelationQuestionBox").val() == $(this).val())
				$("#disCorrelationQuestionBox").val($("#disCorrelationQuestionBox option:enabled:first").val());
		});
	},

	clearFilterSelections: function() {
		HTMLHelpers.setSelectedValues($("#disFilterBox div select"), 0);
	},

	resetOptionalSettings: function() {
		$("#disOptionalFilterSettings input[type='checkbox']").attr("checked", true);
	},

	resetTimeSettings: function () {
		$("#ddlDISTimePeriod").val(20);

		$("#txtDISStartDate").datepicker("setDate", DynamicIconShapeSetup.strToDate($("#txtStartDate").attr("defaultdate")));
		$("#txtDISStopDate").datepicker("setDate", DynamicIconShapeSetup.strToDate($("#txtStopDate").attr("defaultdate")));

		$("#txtDISStartDate").datepicker("option", "defaultDate", DynamicIconShapeSetup.strToDate($("#txtStartDate").attr("defaultdate")));
		$("#txtDISStopDate").datepicker("option", "defaultDate", DynamicIconShapeSetup.strToDate($("#txtStopDate").attr("defaultdate")));
	},

	strToDate: function (str) {
		if (str.startsWith("/Date("))
			return new Date(parseInt(str.substr(6)));
		var arr = str.split(",");
		return new Date(arr[0], arr[1], arr[2]);
	},

	toSvgGradient: function (iconGradient) {
		return {
			orientation: iconGradient.Orientation,
			stops: [{
				"stop-color": iconGradient.FillColor,
				"offset": iconGradient.Offset
			}, {
				"stop-color": iconGradient.BackgroundColor,
				"offset": iconGradient.Offset
			}]
		};
	},
	getTemplateData: function (templateId, templateElementItemId) {
		var data = {
			templateDataGroupId: templateElementItemId,
			templateId: templateId
		};

		Helpers.perfJSonCall({
			method: "TemplateDataGroupData", data: data,
			successCallback: function (result) { DynamicIconShapeSetup.populateDataSectionEdit(result); },
			fixCasing: true
		});
	},
	populateDataSectionEdit: function (result) {
		if (result.length === 0) {
			$('.dataSection').hide();
			$('#wizardDynamicIconShapeVariables').closest('fieldset').removeClass('expandable').addClass('collapsable');
			return;
		}
		$("#dynamicTemplateQA").empty();
		$("#dynamicTemplateFilters").empty();
		$("#dynamicTemplateCalcType").empty();
		for (var i = 0; i < result.length; i++) {
			if (result[i].isWizard)
				if (result[i].type.includes("disQnA"))
					$("#dynamicTemplateQA").append('<li>' + result[i].data + '</li>');
				else if (result[i].type.includes("disFilter"))
					$("#dynamicTemplateFilters").append('<li>' + result[i].data + '</li>');
				else if (result[i].type.includes("disCalc"))
					$("#dynamicTemplateCalcType").append('<li>' + result[i].data + '</li>');
		}
	},
	initWizard: function(templateId) {
		var $setup = $('#setupDynamicIconShapeTab');

		// Append controls to Wizard
		$('#wizardDynamicIconShapeVariables').append($setup.find('#dis_variables_selection > .settingItem').addClass('size-1-2'));
		$('#wizardDynamicIconShapeFilters').append($setup.find('#disFilterBox'));
		$('#wizardDynamicIconShapeTime').append($setup.find('#disTimeSelections > .settingsFieldsetContent').removeClass('settingsFieldsetContent'));
		$('#wizardDynamicIconShapePreview').append($setup.find('#iconPreview'));

		$('#wizardDynamicIconShapePreviewButton').unbind('click.wizardSetup').bind('click.wizardSetup', DynamicIconShapeSetup.updatePreview);

		// Hide
		$setup.find('#dynIconShapeSettingsTabHolder, #iconPreview .DUIToolbar').css('display', 'none');
		$('#DUI-ST-MULTIEDIT').css('display', 'none');
		$('#wizardDynamicIconShape').css('display', '').find('.tabs + .expandable > .settingsFieldsetLegend').trigger('click');
		$('#setupHolder').addClass('setupWizard');
		// Template Data
		if (templateId != null) {
			$('.dataSection').show();
			$('#wizardDynamicIconShapeVariables').closest('fieldset').removeClass('collapsable').addClass('expandable');
			DynamicIconShapeSetup.templateId = templateId;
		}
		else {
			$('.dataSection').hide();
			$('#wizardDynamicIconShapeVariables').closest('fieldset').removeClass('expandable').addClass('collapsable');
		}
	},
	destroyWizard: function() {
		var $setup = $('#setupDynamicIconShapeTab');

		if ($('#dynIconShapeSettingsTabHolder > .tabs .setupWizardInit').length === 0) {
			$setup.find('#dynIconShapeSettingsTabHolder > .tabs').prepend('<li class="ui-state-default setupWizardInit"><a>Wizard</a></li>');
			$('#dynIconShapeSettingsTabHolder > .tabs .setupWizardInit').bind('click', DynamicIconShapeSetup.initWizard);
		}

		// Append controls to chart setup
		$setup.find('#dis_variables_selection').append($('#wizardDynamicIconShapeVariables > .settingItem').removeClass('size-1-2'));
		$setup.find('#dis_filters .settingsFieldset:first-child .settingsFieldsetContent').append($('#wizardDynamicIconShapeFilters #disFilterBox'));
		$setup.find('#disTimeSelections').append($('#wizardDynamicIconShapeTime > div').addClass('settingsFieldsetContent'));
		$setup.find('.preview-groupings').prepend($setup.find('#iconPreview'));

		$setup.find('#dynIconShapeSettingsTabHolder, #iconPreview .DUIToolbar').css('display', '');
		$('#DUI-ST-MULTIEDIT').css('display', 'none');
		$('#wizardDynamicIconShape').css('display', 'none');
		$('#setupHolder').removeClass('setupWizard');
	},
	removeWizard: function() {
		if ($('#setupHolder').hasClass('setupWizard')) DynamicIconShapeSetup.destroyWizard();
		$('#dynIconShapeSettingsTabHolder > .tabs .setupWizardInit').remove();
	}
}
